export const SYNC_HEAD_NAME = 'sync';
